var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "DialogBase",
    {
      attrs: {
        visible: _vm.dialogVisible,
        title: "Thông báo hệ thống",
        width: "70%",
        top: "2vh",
        "close-on-click-modal": false,
        "panel-icon": "el-icon-bell",
        "panel-title": "Nội dung thông báo",
        "panel-subtitle": "Xem nội dung và tải xuống các file đính kèm",
        "show-footer": false,
      },
      on: { "update:visible": _vm.handleVisibleUpdate },
    },
    [
      _c("div", { staticClass: "hr" }, [_c("hr")]),
      _c("div", { staticClass: "table-content row-data" }, [
        _c("div", { staticClass: "title" }, [
          _c("span", { staticClass: "label" }, [_vm._v("Tiêu đề :")]),
          _vm._v("\n      " + _vm._s(this.viewContent.sendTitle) + "\n    "),
        ]),
        _c(
          "div",
          { staticClass: "content" },
          [
            _c("span", { staticClass: "label" }, [_vm._v("Nội dung :")]),
            _c("el-input", {
              attrs: { type: "textarea", rows: 10, readonly: "" },
              model: {
                value: this.viewContent.sendContent,
                callback: function ($$v) {
                  _vm.$set(this.viewContent, "sendContent", $$v)
                },
                expression: "this.viewContent.sendContent",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "file" },
          [
            _c("span", { staticClass: "label" }, [_vm._v("File đính kèm :")]),
            _c("el-upload", {
              ref: "upload",
              staticClass: "upload-demo",
              staticStyle: { "margin-top": "10px" },
              attrs: {
                action: "",
                multiple: "",
                "auto-upload": false,
                limit: 5,
                "file-list": _vm.viewContent.urlFileAppSendList,
                "on-preview": _vm.handleFileRequest,
              },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }